import React, { useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Container, Figure, Row } from "react-bootstrap";
import { sponsors } from "../components/shared/constraints";
import { Link, useNavigate } from "react-router-dom";
import { getTeamApi } from "../hooks/ApisContainer/User";
import useToastContext from "../hooks/useToastContext";
import { BASE_URL } from "../services/path";
import LottiLoader from "../components/shared/Loader/LottiLoader";

const AboutUs = () => {
  const notification = useToastContext();
  const navigate = useNavigate();

  // ALL STATE
  const [teamList, setTeamList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchedGetUsers();
  }, []);

  const fetchedGetUsers = (data = {}) => {
    const requestPayload = { page: 1, pageSize: 100 };
    getTeamApi(requestPayload, notification, (loading, error, response) => {
      setLoader(loading);
      if (!error) {
        setTeamList(response?.docs);
      }
    });
  };

  const positionMapping = {
    Guard: "सरक्षक",
    ChiefSecretary: "अध्यक्ष",
    GeneralTreasury: "महासचिव",
    Chief: "कोषाध्यक्ष",
    VicePresident: "उपाध्यक्ष",
    "Co-Treasurer": "सह कोषाध्यक्ष",
    JointSecretary: "संयुक्त सचिव",
    OrganizationSecretary: "संगठन सचिव",
    WomenCellInCharge: "महिला प्रकोष्ठ प्रभारी",
    YouthCellInCharge: "युवा प्रकोष्ठ प्रभारी",
    CulturalInCharge: "सांस्कृतिक प्रभारी",
    MediaInCharge: "मीडिया प्रभारी",
    Volunteer: "कार्यकारणी सदस्य",
  };
  const renderPosition = (position) => {
    return positionMapping[position] || position; // Fallback to original value if no match is found
  };

  return (
    <div className="inner-wrapper pb-0">
      <div className="page-title mb-md-5 mb-4">
        <div class="common-heading text-center mb-sm-3 mb-2">
          <h2>About Us </h2>
        </div>
        <Breadcrumb>
          <Breadcrumb.Item
            onClick={() => navigate("/")}
            className="text-decoration-none "
          >
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active className="text-orange">
            About Us
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <section className="about-us-sec">
        <Container>
          <div className="about-infor mb-md-5 mb-4">
            <div class="common-heading text-center mb-3">
              <h2>
                {" "}
                Welcome to{" "}
                <span className="text-orange">Saryuparin Brahman Samaj!</span>
              </h2>
            </div>
            <p>
              The Saryuparin Brahman Samaj Rajasthan, Jaipur is a vibrant
              community dedicated to preserving the rich traditions and values
              of the Saryuparin Brahman lineage. As a collective of individuals
              connected by heritage and shared goals, we serve as a hub for
              cultural, spiritual, and social engagement. Our platform aims to
              bridge the gap between generations, fostering unity and mutual
              support within the community while adapting to the evolving world
              around us.{" "}
            </p>

            <p className="mb-0">
              At Sayuparain Brahman Samaj, we strive to nurture a sense of
              belonging among our members. Our primary goal is to celebrate our
              unique identity and contribute positively to society. By staying
              rooted in our traditions and embracing modern ideals, we empower
              individuals to grow personally and professionally while remaining
              connected to their cultural heritage.
            </p>
          </div>

          <div className="what-we-do mb-md-5 mb-3">
            <div class="common-heading text-center mb-3">
              <h2> What we do</h2>
            </div>
            <Row>
              <Col md={4} className="d-flex mb-2">
                <div className="box-do border p-lg-4 p-3 w-100">
                  <figure className="mb-4">
                    <img
                      src="../assets/images/event.png"
                      alt=""
                      className="m-auto"
                    />
                  </figure>
                  <figcaption>
                    <h2 className="fs-4 fw-bold">Cultural Events</h2>
                    <p>
                      Celebrating festivals, organizing gatherings, and
                      preserving our traditions.
                    </p>
                  </figcaption>
                </div>
              </Col>
              <Col md={4} className="d-flex mb-2">
                <div className="box-do border p-lg-4 p-3 w-100">
                  <figure className="mb-4">
                    <img
                      src="../assets/images/event.png"
                      alt=""
                      className="m-auto"
                    />
                  </figure>
                  <figcaption>
                    <h2 className="fs-4 fw-bold">Matrimonial & Support</h2>
                    <p>
                      Offering matrimonial relationships, career guidance, and
                      mentoring programs.
                    </p>
                  </figcaption>
                </div>
              </Col>

              <Col md={4} className="d-flex mb-2">
                <div className="box-do border p-lg-4 p-3 w-100">
                  <figure className="mb-4">
                    <img
                      src="../assets/images/event.png"
                      alt=""
                      className="m-auto"
                    />
                  </figure>
                  <figcaption>
                    <h2 className="fs-4 fw-bold">Social Welfare</h2>
                    <p>
                      Engaging in charitable initiatives to support the
                      underprivileged.
                    </p>
                  </figcaption>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <section className="sponser-sec  pt-0 our-team-member pb-0 ">
        <Container>
          <div class="common-heading text-center mb-4">
            <h2>
              Our <span className="text-orange">Team Member</span>
            </h2>
          </div>
          {loader ? (
            <Row className="achiever-box">
              <Container className="d-flex justify-content-center align-items-center default-back">
                <span>
                  <LottiLoader height={120} width={120} loader={true} />
                </span>
              </Container>
            </Row>
          ) : (
            <Row className="achiever-box">
              {teamList &&
                teamList.length > 0 &&
                teamList?.map((sponsor, index) => (
                  <Col
                    lg={3}
                    md={4}
                    xs={6}
                    className="mb-md-5 mb-3"
                    key={sponsor?._id}
                  >
                    <Card className="sponser-cards speaker-box-layout2 position-relative">
                      <Figure>
                        <Card.Img
                          variant="top"
                          src={
                            BASE_URL + "/uploads/" + sponsor?.volentierPic || ""
                          }
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src =
                              "https://t4.ftcdn.net/jpg/07/95/29/45/240_F_795294584_LZ4NllndEBSy8vbi37sYngiLIaPdUvtQ.jpg";
                          }}
                          alt="Profile"
                        />
                      </Figure>
                      <Card.Body className="text-start">
                        <Card.Title className="fs-6 fw-bold">
                          {sponsor.name}
                        </Card.Title>
                        <Card.Text
                          style={{ color: "gray", fontSize: "14px" }}
                          className="mb-0"
                        >
                          {renderPosition(sponsor?.position)}
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
            </Row>
          )}
        </Container>
      </section>
    </div>
  );
};

export default AboutUs;
